import React from 'react';
import { connect } from 'react-redux';
import unique from 'array-unique';
import Tracker from '../../../../genesys/tracker';

class F_4 extends React.Component {
    constructor(props) {
        super(props);

        this.gotoNextStep = this.gotoNextStep.bind(this);
    }

    localize(message) {
        return this.props.config.labels[message] || message;
    }
    
    formatHtml(message) {
        return message.replace(/(&nbsp;)/ig, ' '); // in ' ' is non-breaking-space (U+00A0) which will be replaced by real &nbsp; by react.
    }

    componentDidMount() {
        if(!this.props.config) {
            Tracker.sendEvent('mobileCallGet', { login_type: 'changed', userIdentificationNumber: this.props.call.registration.userIdentificationNumber });
        }
        else {
            this.skipCategories();
        }
    }

    skipCategories() {
        let categories = this.props.call.registration.login_type === 'offer' ? this.props.config.offer.callCategories : this.props.config.full.callCategories;
        let categoryLine = this.props.call.registration.categoryLine;
        if(categoryLine === null) {
            const v = unique(categories.map(c => c.categoryLine));
            if(v.length === 1) {
                categoryLine = v[0];
            }
        }
        let categorySegment = this.props.call.registration.categorySegment;
        if(categoryLine !== null && categorySegment === null) {
            const v = unique(categories.filter(c => c.categoryLine === categoryLine).map(c => c.categorySegment));
            if(v.length === 1) {
                categorySegment = v[0];
            }
        }
        let categoryId = null;
        let categoryTel = null;
        if(categoryLine !== null && categorySegment !== null) {
            if(categories.length > 1) {
                categories = categories.filter(c => c.categoryLine === categoryLine && c.categorySegment === categorySegment);
            }
            else {
                categoryId = categories[0].categoryId;
                categoryLine = categories[0].categoryLine;
                categorySegment = categories[0].categorySegment;
                categoryTel = categories[0].categoryTel;
            }
        }

        if(this.props.call.registration.categoryLine != categoryLine ||
            this.props.call.registration.categorySegment != categorySegment ||
            this.props.call.registration.categoryId != categoryId) {
            this.props.saveValues({categoryLine, categorySegment, categoryId, categoryTel});
        }
        if(categoryId) {
            this.props.nextStep('F_5');
        }
    }

    componentDidUpdate() {
        if(this.props.config) {
            this.skipCategories();
        }
    }

    gotoNextStep(e) {
        e.preventDefault();

        if(e.target.dataset['type'] === 'categoryLine') {
            this.props.saveValues({categoryLine: e.target.value});
        }
        else if(e.target.dataset['type'] === 'categorySegment') {
            this.props.saveValues({categorySegment: e.target.value});
        }
        else {
            this.props.saveValues({categoryId: e.target.value, categoryTel: e.target.dataset['tel'], categoryCMB: e.target.dataset['cmb'] === 'true', categoryOffline: e.target.dataset['offline'] === 'true', categoryOfflineDescription: e.target.dataset['offlinedescription'] || null});
            this.props.nextStep('F_5');
        }
    }

    render() {
        if(this.props.config) {
            let categoryLine = this.props.call.registration.categoryLine;
            let categorySegment = this.props.call.registration.categorySegment;
            let categories = this.props.call.registration.login_type === 'offer' ? this.props.config.offer.callCategories : this.props.config.full.callCategories;
            let values;
            if(categoryLine === null) {
                values = unique(categories.map(c => c.categoryLine)).map(line => (
                    <span key={line}>
                        <button onClick={this.gotoNextStep} value={line} data-type="categoryLine">{this.formatHtml(this.localize(line))}</button>
                    </span>)
                );
            }
            else if(categorySegment === null) {
                values = unique(categories.filter(c => c.categoryLine === categoryLine).map(c => c.categorySegment)).map(segment => (
                    <span key={segment}>
                        <button onClick={this.gotoNextStep} value={segment} data-type="categorySegment">{this.formatHtml(this.localize(segment))}</button>
                    </span>)
                );
            }
            else {
                values = categories.filter(c => c.categoryLine === categoryLine && c.categorySegment === categorySegment).map((category, i) => (
                    <span key={i}>
                        <button onClick={this.gotoNextStep} value={category.categoryId} data-type="categoryId" data-tel={category.categoryTel} data-cmb={category.categoryCMB || false} data-offline={category.categoryOffline || false} data-offlinedescription={category.categoryOfflineDescription}>{this.formatHtml(category.categoryName)}</button>
                    </span>)
                );
            }
            return (
                <div className="click2call--groups">
                    <div className="click2call--group click2call--group-label">
                        <p>Połączymy Cię bezpośrednio z doradcą, wybierz temat rozmowy:</p>
                    </div>
                    <div className="click2call--group">
                        <div className="click2call--content-radio">
                            {values}
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="click2call--groups">
                    <div className="click2call--group click2call--group-label">
                        <p>Pobieram dane…</p>
                    </div>
                    <div className="click2call--group">
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        call: state.call,
        main: state.main,
        engagementId: state.config.widget ? state.config.widget.engagementId : null,
        config: state.config.widget ? state.config.widget.callOptions : null
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(F_4);
